"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.escapeRegEx = exports.validateLocale = void 0;
function validateLocale(locale) {
    try {
        new Intl.NumberFormat(locale);
        return locale;
    }
    catch (_a) {
        const errorMessage = `@procore/globalization-toolkit Intl.NumberFormat error for locale ${locale}. Please use a supported locale.`;
        console.error(errorMessage);
        throw new Error(errorMessage);
    }
}
exports.validateLocale = validateLocale;
function escapeRegEx(value) {
    return value.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
exports.escapeRegEx = escapeRegEx;
//# sourceMappingURL=FormatterUtils.js.map